import { useWorkspace } from "../workspace/WorkspaceContext";

/** MC-05: owner/admin only. The API is the real guard (403); the UI just hides the entry points. */
export function useMayUseConsole(): boolean {
  const { workspace } = useWorkspace();
  return workspace.isOwner || ["owner", "admin"].includes(workspace.role.toLowerCase());
}
